if (!customElements.get('contact-form-panel')) {
  customElements.define(
    'contact-form-panel',
    class ContactFormPanel extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('.contact-form__form');
        const errorSummary = this.querySelector('.contact-form__feedback--error');

        if (form && errorSummary?.id) {
          form.setAttribute('aria-describedby', errorSummary.id);
        }
      }
    }
  );
}
